export const getShortAddress = (companyAddress: string) => {
  if (!companyAddress) {
    return null;
  }
  return `${companyAddress?.substring(0, 2)}...${companyAddress?.substring(
    companyAddress?.length - 4
  )}`;
};
